var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('EPSHeader'),_c('router-view'),_c('br'),_c('br'),_c('EPSFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }